module.exports = __webpack_public_path__ + "img/大雪.e4646ae9.png";